import IconEdit from "../icon/IconEdit";
import { IconButtonContainer, IconButtonProps } from "./IconButtonContainer";

export default function IconButtonEdit(props: IconButtonProps) {
    return <IconButtonContainer {...props}>
        <IconEdit />
    </IconButtonContainer>
}